var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { FaClockRotateLeft } from "react-icons/fa6";
import { IconButton, Link, List, ListIcon, ListItem, Popover, PopoverArrow, PopoverBody, PopoverCloseButton, PopoverContent, PopoverHeader, PopoverTrigger, Spinner } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
export const Versions = (props) => {
    const [loading, setLoading] = useState(false);
    const [versions, setVersions] = useState([]);
    useEffect(() => {
        const load = () => __awaiter(void 0, void 0, void 0, function* () {
            setLoading(true);
            const response = yield fetch("/api/asset/" + props.assetId + "/version");
            const data = yield response.json();
            setVersions(data);
            setLoading(false);
        });
        load();
    }, [props.assetId]);
    return (React.createElement(Popover, null,
        React.createElement(PopoverTrigger, null,
            React.createElement(IconButton, { title: "Archiv", variant: "ghost", "aria-label": "Versionen anzeigen", icon: React.createElement(FaClockRotateLeft, { color: "#003366", size: "1.2rem" }) })),
        React.createElement(PopoverContent, null,
            React.createElement(PopoverArrow, null),
            React.createElement(PopoverCloseButton, null),
            React.createElement(PopoverHeader, null, "\u00C4ltere Versionen anzeigen"),
            React.createElement(PopoverBody, null, loading ?
                React.createElement(Spinner, null)
                :
                    React.createElement(List, { spacing: 3 }, versions.map(version => (React.createElement(ListItem, { key: version.id, display: "flex", alignItems: "center" },
                        React.createElement(ListIcon, { as: FaClockRotateLeft, color: 'brand.800' }),
                        React.createElement(Link, { href: "/api/asset/" + props.assetId + "/version/" + version.id }, version.title)))))))));
};
